export default (theme) => ({
  root: {
    flex: 1
  },
  grid: {
    textAlign: 'center',
    minHeight: '50vh'
  }
})
